module.exports = __webpack_public_path__ + "media/views/builder/sites/assets/checkbox_checked-35b6b30b5375c02fdfeff7f6ce2ff9db.svg";